var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"to":"atlas-sidebar-title"}},[_c('span',[_vm._v(_vm._s(_vm.$t('ATLAS.APPLICATIONS_MANAGER.TITLE')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }